module.exports = __webpack_public_path__ + "img/backgroundImg.e2c3c754.png";